import axios from 'axios'
import { URL_BACKOFFICE } from '@/configs'
import { getAuthHeader } from '@/firebase/config'

const { get } = axios

export const listTenants = async () =>
  get(`${URL_BACKOFFICE}/tenants`, await getAuthHeader()).then(
    ({ data }: any) => {
      const tenants = data.tenants
      return tenants.map((t: any, idx: number) => ({
        idx: idx + 1,
        ...t,
      }))
    }
  )

export default {
  listTenants,
}
